module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-BoldItalic_1_9bd635e8.abe8c9c9.ttf";